module.exports = __webpack_public_path__ + "static/planet2.cfc91b9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/planets/planet2.svg
// module id = 696
// module chunks = 213534597649335